import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/invision': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M407.4 32c22.4 0 40.6 18.2 40.6 40.6v366.8c0 22.4-18.2 40.6-40.6 40.6h-366.8c-22.4 0-40.6-18.2-40.6-40.6v-366.8c0-22.4 18.2-40.6 40.6-40.6h366.8zM176.1 145.6c-0.6-35.1-53.6-34.8-53.7 0.4 0 15 12.2 27 27.1 27 4.2-0.1 27-4 26.6-27.4zM332.8 377c23.8 0 42.7-15.3 53.2-52l-17.9-6.7c-14.3 39.5-31.8 32.4-31.8 16.9 0.3-8.1 0.7-7.7 14.9-58.8 26.1-85.8-61.3-113.5-101.8-38l8.9-40.5h-68.8l-9.7 35.6h32.3l-19.8 79.4c-16.5 36.7-57.4 44.1-57.4 23.2 0.3-11.3-0.7-4.5 32.9-138.2h-76.4l-9.7 35.6h31.8c-22.1 90.1-22.9 89.8-23 104.1 0 48.7 63.1 56.1 94.6 4.3l-8.1 32.5h45.1l25.8-103.3c14.7-59.7 74-47.1 59.9-0.7-9.1 32.6-40.6 106.6 25 106.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/invision.js
// module id = 892
// module chunks = 0